import IconEuro from '@fortuneo/ui-icons/general/IconEuro'
import React from 'react'

export const endAdornments = [
  {
    element: <IconEuro opacity={0.54} />,
  },
]
